import { baseServiceRequest } from "@apis/baseServiceRequest"
import type { IUtility } from "./types"

export const getUtility = async (utility_code: string): Promise<IUtility> => {
  const response = await baseServiceRequest({
    method: "GET",
    url: `/utilities/${utility_code}`,
  })
  return response.data
}

export const getUtilityBillCycles = async (
  utility_code: string,
): Promise<string[]> => {
  const response = await baseServiceRequest({
    method: "GET",
    url: `/utilities/${utility_code}/bill_cycles`,
  })
  return response.data
}
